module.exports = __webpack_public_path__ + "img/arrow-right.de01669e.svg";